import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Box,
  AppBar,
  Tabs,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Snackbar, Divider,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SchoolIcon from '@mui/icons-material/School';
import PaidIcon from '@mui/icons-material/Paid';
import PublicIcon from '@mui/icons-material/Public';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // CheckCircle icon for better visual representation
import EventIcon from '@mui/icons-material/EventAvailable';
import ActivitiesIcon from '@mui/icons-material/Star';
import ukdegree from '../img/ukdegree.jpg';
import Webhead from '../Webhead';
import { useState } from 'react';
import Webfoot from '../Webfoot';


const Ruk = () => {

  const [value, setValue] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const benefits = [
    {
      title: "Strong economy with established industries",
      // description: "UK offers a lower cost of living and tuition fees compared to other popular study destinations.",
      icon: <PaidIcon />
    },
   
    {
      title: "Vibrant, entrenched Indian community",
      // description: "UK provides pathways for international students to apply for permanent residency.",
      icon: <PublicIcon />
    },
    {
      title: "Exceptional and free healthcare via NHS",
      // description: "Experience vibrant student life, cultural diversity, and a wide range of extracurricular activities.",
      icon: <EmojiPeopleIcon />
    },
    {
      title: "Home to some of the world’s best universities",
      // description: "UK is known for its safety and welcoming atmosphere, providing peace of mind to students.",
      icon: <LiveHelpIcon />
    },
    {
      title: "Powerful passport to facilitate global travel",
      // description: "International students can work part-time while studying, gaining valuable experience.",
      icon: <SchoolIcon />
    },
    {
      title: "High demand for skilled talent",
      // description: "Students can engage in groundbreaking research and collaborate with leading experts.",
      icon: <SchoolIcon />
    },
  ];

  return (
    <div>
      <Webhead />
      <div>
        {/* <StudyInUK /> */}
        <Container maxWidth="lg" style={{ marginTop: '20px', marginBottom: '40px' }}>

          <Box
            sx={{
              backgroundImage: `url(${ukdegree})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              color: 'white',
              padding: '100px 20px',
              textAlign: 'center',
            }}
          >
            <Typography variant="h4" gutterBottom>
              Pursue Your Higher Education In An UK University
            </Typography>
            <Typography variant="h6" paragraph>
              Complete Admissions Support to Study in UK
            </Typography>
            <Button variant="contained" color="primary" onClick={() => setSnackbarOpen(true)}>
              Get Started
            </Button>
          </Box>

          {/* Tabs for Different Sections */}
          <AppBar position="static" color="default">
            <Tabs value={value} onChange={handleTabChange} aria-label="tabs">
              <Tab label="Why Settle In The UK?" />
              {/* <Tab label="Admission Process" /> */}
              {/* <Tab label="Student Life" /> */}
            </Tabs>
          </AppBar>

          {/* Tab Content */}
          {value === 0 && (
            <Box sx={{ padding: '5px 0' }}>
              <br />
              <Box sx={{ padding: '20px', backgroundColor: '#F9BB16', borderRadius: '8px', textAlign: 'center' }}>
                <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'black' }}>
                  Study In UK
                </Typography>
              </Box>
              <br />
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'black' }}>

                Settle In The UK With Your Family
              </Typography>
              <Typography variant="body1" paragraph>
                The UK is still one of the world’s greatest countries. It’s incredible quality of life and multicultural cities make it one of the most attractive destinations for professionals seeking a better life for themselves and their families. Despite the upheaval of Brexit, it retains a strong economic position due to its established institutions and deep involvement in global trade. Allians International can help you navigate the intricacies of UK immigration law to help you settle in the world’s premier English speaking destination.
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'black' }}>

                Why Settle In The UK?
              </Typography>
              <br />
              <Grid container spacing={2} justifyContent="center">

                {benefits.map((benefit, index) => (
                  <Grid item xs={6} sm={6} md={6} key={index}>
                    <Card variant="outlined" sx={{ display: 'flex', alignItems: 'center', padding: '16px', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}>
                      <IconButton color="primary" sx={{ marginRight: '16px' }}>
                        {benefit.icon}
                      </IconButton>
                      <CardContent sx={{ flex: 1 }}>
                        <Typography variant="h6" gutterBottom>
                          {benefit.title}
                        </Typography>
                        {/* Uncomment below line if you want to include the description */}
                        {/* <Typography variant="body2">{benefit.description}</Typography> */}
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}


          {value === 1 && (
            <Box sx={{ padding: '20px', borderRadius: '8px', backgroundColor: '#fafafa' }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                Admission Process
              </Typography>
              <Typography variant="body1" paragraph>
                The admission process for studying in UK typically includes the following steps:
              </Typography>
              <ul style={{ listStyleType: 'none', padding: 0 }}>
                {[
                  "Choose a program and institution.",
                  "Check the admission requirements.",
                  "Prepare required documents (transcripts, letters of recommendation, etc.).",
                  "Submit your application online.",
                  "Receive an acceptance letter and pay tuition fees.",
                  "Apply for a study permit.",
                ].map((step, index) => (
                  <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#fff' }}>
                    <SchoolIcon color="primary" style={{ marginRight: '10px' }} />
                    <Typography variant="body1">{step}</Typography>
                  </li>
                ))}
              </ul>
            </Box>
          )}

          {value === 2 && (
            <Box sx={{ padding: '20px', borderRadius: '8px', backgroundColor: '#fafafa', marginTop: 4 }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                Student Life
              </Typography>
              <Typography variant="body1" paragraph>
                Student life in UK is diverse and vibrant. You can expect to engage in:
              </Typography>
              <ul style={{ listStyleType: 'none', padding: 0 }}>
                {[
                  "Participating in clubs and organizations.",
                  "Attending social events and networking opportunities.",
                  "Enjoying the cultural and recreational activities in your area.",
                ].map((activity, index) => (
                  <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#fff' }}>
                    <EventIcon color="primary" style={{ marginRight: '10px' }} />
                    <Typography variant="body1">{activity}</Typography>
                  </li>
                ))}
              </ul>
            </Box>
          )}
          <Box sx={{ padding: '20px' }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
              Documents Required For Migrating To The UK
            </Typography>
            <Divider sx={{ marginBottom: 2 }} />
            <Typography variant="body1" paragraph>
              – You need to take the English Language Proficiency Test. This mainly includes IELTS and TOEFL.
            </Typography>
            <Typography variant="body1" paragraph>
              – You should belong to a country that is not included in the European Economic Area or the EEA.
            </Typography>
            <Typography variant="body1" paragraph>
              – You should have all the required documents, work experience certificates, and others needed to enroll in a college or apply for a job to enter the UK.
            </Typography>
            <Typography variant="body1" paragraph>
              – You should have the required amount of funds needed to support yourself during your stay on a student or work visa for the initial years in the UK.
            </Typography>
            <Typography variant="body1" paragraph>
              – You are also required to submit character and health certificates that will further prove your qualification for the required visa.
            </Typography>
            <Divider sx={{ margin: '20px 0' }} />

            <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
              UK Immigration Process
            </Typography>
            <Divider sx={{ marginBottom: 2 }} />
            <Typography variant="body1" paragraph>
              The United Kingdom comprises England, Wales, Scotland, and Northern Ireland. Being one of the world’s most sought-after migration destinations, the UK offers an array of options for individuals seeking to settle down. Typically, individuals need to first move to the UK temporarily and then apply for an ILR (Indefinite Leave to Remain). Some of the ways to move to the UK include:
            </Typography>
            <Typography variant="body1" paragraph>
              – Migrating to the UK with a job offer on hand
            </Typography>
            <Typography variant="body1" paragraph>
              – Settling down in the UK through the student route
            </Typography>
            <Typography variant="body1" paragraph>
              – Settling down in the UK if you are married or engaged to a UK citizen or permanent resident
            </Typography>
            <Typography variant="body1" paragraph>
              – Migrating to the UK as an entrepreneur setting up a business
            </Typography>
            <Typography variant="body1" paragraph>
              – Migrating to the UK as an investor
            </Typography>
            <Typography variant="body1" paragraph>
              In order to migrate to the UK, candidates will need a good IELTS score and must meet all professional, legal, and financial criteria. These criteria depend on your chosen migration path. Allians International helps individuals identify the correct immigration route and then assists them at every step of their migration journey. Our two decades of immigration experience make us your best option to increase your chances of settling down in the UK.
            </Typography>
            <Divider sx={{ margin: '20px 0' }} />

            <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
              Roadmap To The UK
            </Typography>
            <Divider sx={{ marginBottom: 2 }} />
            <Typography variant="body1" paragraph sx={{ fontWeight: 'bold'}} >
              Highly qualified foreigners
            </Typography>
            <Typography variant="body1" paragraph>
              Tier 1 (Exceptional Talent) Visa
            </Typography>
            <Typography variant="body1" paragraph>
              Tier 1 (Investor) Visa
            </Typography>
            <Typography variant="body1" paragraph>
              Tier 1 (Entrepreneur) Visa
            </Typography>
            <Typography variant="body1" paragraph>
              Tier 1 (Graduate Entrepreneur) Visa
            </Typography>

            <Typography variant="body1" paragraph sx={{ fontWeight: 'bold'}} >
              Skilled foreign workers with a job offer in a shortage area
            </Typography>
            <Typography variant="body1" paragraph>
              Tier 2 (General) Visa
            </Typography>
            <Typography variant="body1" paragraph>
              Tier 2 (Intra-company Transfer) Visa
            </Typography>
            <Typography variant="body1" paragraph>
              Tier 2 (Sportsperson) Visa
            </Typography>
            <Typography variant="body1" paragraph>
              Tier 2 (Minister of Religion) Visa
            </Typography>

            <Typography variant="body1" paragraph sx={{ fontWeight: 'bold'}} >
              Youth mobility and temporary foreign workers
            </Typography>
            <Typography variant="body1" paragraph>
              Tier 5 (Temporary Worker) Visa
            </Typography>
            <Typography variant="body1" paragraph>
              Tier 5 (Youth Mobility Scheme) Visa
            </Typography>
          </Box>


          {/* Snackbar for user feedback */}
          <Snackbar
            open={snackbarOpen}
            onClose={handleSnackbarClose}
            message="Get Started button clicked!"
            autoHideDuration={4000}
          />
        </Container>
      </div>
      <Webfoot />
    </div>
  );
};

export default Ruk;